import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/context/AuthContext';

export function AccessDenied() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div 
      className="flex min-h-screen items-center justify-center bg-background p-4"
      data-testid="access-denied-page"
    >
      <Card className="w-full max-w-md border-destructive/50 bg-card">
        <CardContent className="flex flex-col items-center py-12 text-center">
          <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
            <ShieldX className="h-10 w-10 text-destructive" />
          </div>
          
          <h1 className="mb-2 text-2xl font-bold tracking-tight text-foreground">
            Access Denied
          </h1>
          
          <p className="mb-8 text-muted-foreground">
            You do not have administrator privileges to access this panel.
            Please contact your system administrator if you believe this is an error.
          </p>

          <Button
            variant="outline"
            onClick={handleLogout}
            className="gap-2"
            data-testid="back-to-login-btn"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default AccessDenied;
